import { EventEmitter } from 'InterfaceBundle'

export const ChatManager = {
	focus: new EventEmitter(),
	activeRoom: null
}